module.exports = __webpack_public_path__ + "static/img/cyber.41d23509.png";